import { render, staticRenderFns } from "./ApuracaoAcaoArquivos.vue?vue&type=template&id=5bed6ecc"
import script from "./ApuracaoAcaoArquivos.vue?vue&type=script&lang=js"
export * from "./ApuracaoAcaoArquivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports